import { ApiSimpleProduct } from "@incendium/api";
import { listSubscriptionProducts } from "features/subscription";
import { useGlobalSharedState } from "Hooks/useSharedState";

const fetchSubscriptionProducts = async () => {
  const products = await listSubscriptionProducts();
  return products || [];
};

const useSubscriptionProducts = () => {
  const { state, setState, loading, refetch } = useGlobalSharedState<ApiSimpleProduct[]>(
    "subscriptionProducts",
    [],
    fetchSubscriptionProducts
  );

  return {
    subscriptionProducts: state,
    setSubscriptionProducts: setState,
    loading,
    refetch,
  };
};

export default useSubscriptionProducts;
